<ra-modal
    [title]="'order.create.title' | translate"
    [pushed]="orderCreateService.showCreateClient()"
    [disabled]="creating()"
    (close)="close.emit()">

    @let step = orderCreateService.step();

    <!-- Descrição -->
    @if (step == 0) {
        <order-description (close)="close.emit()" />
    }

    <!-- Lista de clientes -->
    @else if (step == 1) {
        <order-list-clients (created)="created.emit($event);" />
    }
</ra-modal>

<!-- Cadastro de cliente por cima do fluxo: ao salvar, volta para a lista com o novo cliente selecionado. -->
@if (orderCreateService.showCreateClient()) {
    <client-settup
        [refreshList]="false"
        (saved)="onClientCreated($event)"
        (close)="orderCreateService.showCreateClient.set(false)"
    />
}
